import Constants from '../../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}devrienden/`;

const title = "Holy Road - De Vrienden";
const description = "Dit verhaal, een reportage waar we trots op waren, staat er niet meer. De reden hiervoor is vrij onaangenaam: de jongens trekken hun medewerking in, uit angst voor bedreigingen.";
const featuredImage = `${imageFolder}devrienden/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}devrienden`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}djv201703101027.jpg`,
            tablet: `${imageFolder}djv201703101027.jpg`,
            desktop: `${imageFolder}djv201703101027.jpg`,
            alt: "",
            text: "Het Jenin-vluchtelingenkamp in 2017."
        }
    },
    {
      type: "Paragraph",
      text: "Hier stond een verhaal over hoop. Een onvervalst feelgoodverhaal, over Palestijnse jongens die groot werden in een oorlogssituatie en desondanks goed terecht waren gekomen. Het waren de vijf jongens van het Jenin-vluchtelingenkamp, vastgelegd door fotograaf Dirk-Jan Visser op het hoogtepunt van de Tweede Intifada en opnieuw bezocht in 2017. De ‘toen-en-nu’-foto’s van het vijftal ontlokten de nodige emoties bij iedereen die ze bekeek."
    },
    {
      type: "Paragraph",
      text: "The Holy Road beoogt een inkijkje te bieden in het dagelijks leven op de Westelijke Jordaanoever, zowel voor Palestijnen als voor Joodse kolonisten. Wat je ook van hun politieke opvattingen vindt, ook de kolonisten ervaren in hun levens menselijke tragedies waar wij verslag van wilden doen. Zie het verhaal over de dertienjarige Hallel Yaffe Ariel, die in haar eigen slaapkamer doodgestoken werd door een Palestijnse jongen."
    },
    {
      type: "Paragraph",
      text: "Naar ons idee zijn we tegenover iedereen duidelijk geweest over onze bedoelingen met The Holy Road. Niettemin bleek begin 2018, toen de Engelse vertaling van de documentaire verscheen, dat onze contactpersoon voor het vluchtelingenkamp in Jenin hevig geschrokken was van het gegeven dat er ook Joodse kolonisten in figureren. Dit naakte feit is voor sommige Palestijnen onacceptabel; het ‘samenwerken’ met de bezetter in één productie zou bijdragen aan ‘normalisatie’ van de bezetting. Deze groep is van mening dat de al meer dan vijftig jaar durende militaire onderdrukking van Palestijnen op de Westelijke Jordaanoever allesbehalve normaal is, en dat er in geen geval gedaan mag worden alsof dit wel het geval is."
    },
    {
      type: "Paragraph",
      text: "De contactpersoon bracht de documentaire nog eens bij de jongens onder de aandacht en gezamenlijk eisten ze dat we hun verhaal eruit zouden schrappen. Hun argumenten: zowel de contactpersoon als de jongens kunnen gezien worden als verraders of collaborateurs, omdat ze met hun deelname aan onze documentaire de bezetting zouden normaliseren."
    },
    {
        type: "Image",
        image: {
            mobile: `${imageFolder}161223000063660057.jpg`,
            tablet: `${imageFolder}161223000063660057.jpg`,
            desktop: `${imageFolder}161223000063660057.jpg`,
            alt: "",
            text: "Het Jenin-vluchtelingenkamp in 2002."
        }
    },
    {
      type: "Paragraph",
      text: "Journalistiek gezien zijn dit voor ons geen valide argumenten. Wij hebben geen pro-Palestijnse of anti-Israëlische propagandafilm gemaakt; wij laten simpelweg de realiteit zien voor beide bevolkingsgroepen. Waar we wel gevoelig voor zijn, is het argument dat de jongens bedreigd zouden kunnen worden. Daarom besluiten we tot dit nieuwe verhaal, om de lastige vragen te onderzoeken rondom normalisatie, de boycotbeweging tegen Israël en interne Palestijnse druk op mensen om zich aan deze normen te conformeren. Het is bepaald geen geïsoleerd incident dat de jongens groepsdruk ervaren om niet aan normalisatie mee te werken; zo schrapt de gemeente Ramallah de vertoning van de voor een Oscar genomineerde, Libanese film The Insult met als argument dat regisseur Ziad Doueiri voor de opnames van een eerdere film enkele weken in Tel Aviv geweest is."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow1/01Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/01Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/01Jenin.jpg`,
                alt: "",
                text: "Het Jenin-vluchtelingenkamp, een paar dagen na operatie ‘Beschermend Schild’."
            },
            {
                mobile: `${imageFolder}slideshow1/02Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/02Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/02Jenin.jpg`,
                alt: "",
                text: "Overal zitten mensen reddeloos op de puinhopen van hun huis."
            },
            {
                mobile: `${imageFolder}slideshow1/03Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/03Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/03Jenin.jpg`,
                alt: "",
                text: "In een cirkel rond het platgewalste deel van het kamp zijn alle huizen zwaar beschadigd."
            },
            {
                mobile: `${imageFolder}slideshow1/04Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/04Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/04Jenin.jpg`,
                alt: "",
                text: "Hulporganisaties hebben water en voedsel voor de getroffenen gebracht."
            },
            {
                mobile: `${imageFolder}slideshow1/05Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/05Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/05Jenin.jpg`,
                alt: "",
                text: "Een oude man zit in gedachten verzonken bij zijn vernielde huis."
            },
            {
                mobile: `${imageFolder}slideshow1/06Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/06Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/06Jenin.jpg`,
                alt: "",
                text: "Hele families brengen de dagen door op de ruïnes van hun huizen."
            },
            {
                mobile: `${imageFolder}slideshow1/07Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/07Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/07Jenin.jpg`,
                alt: "",
                text: "Een jongen klimt op het dak van zijn beschadigde huis."
            },
            {
                mobile: `${imageFolder}slideshow1/08Jenin.jpg`,
                tablet: `${imageFolder}slideshow1/08Jenin.jpg`,
                desktop: `${imageFolder}slideshow1/08Jenin.jpg`,
                alt: "",
                text: "Oude vrouwen overzien de komst van journalisten en hulpverleners naar het vernielde Jenin-vluchtelingenkamp."
            }
        ],
    },
    {
      type: "Paragraph",
      text: "De oproep tot een culturele boycot van Israël is onderdeel van de BDS-beweging, waarbij de afkorting staat voor ‘boycot, desinvesteren en sancties’. Deze beweging werd in 2004 opgericht door Palestijnse activisten. In de decennia daarvoor hadden twee bloedige intifada’s het leven gekost aan duizenden mensen, zonder dat de Palestijnen er in politieke zin iets mee opschoten. Tijd voor geweldloos verzet, vonden ze. Hiermee hopen ze een einde te maken aan de Israëlische bezetting en aan de discriminatie van Palestijnen. Bovendien willen ze dat Israël het recht op terugkeer van Palestijnse vluchtelingen erkent. De tactieken van de activisten weerspiegelen de boycot van het Zuid-Afrikaanse apartheidsregime. Daar heeft de boycot eraan bijgedragen om het regime tot een einde te brengen. Diverse internationale notabelen hebben zich achter de BDS-beweging geschaard. Bekend zijn onder anderen de in maart 2018 overleden wetenschapper Stephen Hawking, schrijver Naomi Klein en de Zuid-Afrikaanse aartsbisschop Desmond Tutu."
    },
    {
      type: "Paragraph",
      text: "Er zijn uiteenlopende ideeën binnen de beweging over wie en wat er precies geboycot moeten worden. Sommigen zeggen: we zijn tegen de bezetting, dus we kopen geen producten die gemaakt zijn in illegale Joodse nederzettingen op de Westelijke Jordaanoever. Anderen kopen helemaal geen Israëlische producten meer: om de bezetting te beëindigen, vinden zij, moet de druk op héél Israël worden opgevoerd. Deze tweede groep wil bijvoorbeeld ook de Israëlische universiteiten boycotten. Nee, zeggen anderen weer: de Israëlische academici vormen juist een groep mensen die we hard nodig hebben voor het verzet van binnenuit."
    },
    {
      type: "Paragraph",
      text: "De bekendste acties van BDS-activisten zijn het verstoren van optredens en de oproepen aan artiesten om niet in Israël op te treden. Zolang de militaire bezetting van Palestijns gebied voortduurt, vinden zij, zouden artiesten Israël moeten mijden. Het gaat om niet de minste namen: van Radiohead tot Britney Spears. Af en toe boeken de activisten succes, zoals in 2017, wanneer de Nieuw-Zeelandse zangeres Lorde besluit om haar geplande optreden in Tel Aviv af te zeggen. Iedere artiest die de Palestijnse druk negeert, wordt – onder de hashtag #BDSFail – dan weer luidkeels bejubeld door pro-Israëlische activisten op de sociale media. Optreden in Israël is een statement geworden."
    },
    {
      type: "Paragraph",
      text: "Een beproefde BDS-methode is ook om bedrijven en overheden die zich inlaten met illegale nederzettingen onder druk te zetten. Ook Nederlandse bedrijven zijn hier gevoelig voor. Zo besloot pensioenfonds PGGM in 2014 om niet meer te beleggen in vijf Israëlische banken die de bouw van Joodse nederzettingen financieren, en verbrak waterbedrijf Vitens een jaar eerder de samenwerking met een Israëlische firma die de nederzettingen van water voorziet."
    },
    {
      type: "Paragraph",
      text: "De economische schade van de BDS-beweging valt mee. Begin 2015 concludeert een rapport van de Knesset, het Israëlische parlement, dat de export naar Europa sinds 2005 juist is verdubbeld, van jaarlijks 7 naar 14 miljard euro. Zelfs als Europa alle producten uit nederzettingen zou boycotten, zou dit Israël jaarlijks hooguit 90 miljoen euro kosten. Toch gaan de politici en de kranten in Israël, behalve de meest linkse, fel tegen BDS tekeer. Premier Netanyahu noemt de beweging ‘antisemitisch’, en oppositieleider Herzog vergelijkt een boycot zelfs met ‘een nieuwe intifada’."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu01.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu01.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu01.jpg`,
                alt: "",
                text: "Toen in 2002 en nu in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu02.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu02.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu02.jpg`,
                alt: "",
                text: "Toen in 2002 en nu in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu03.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu03.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu03.jpg`,
                alt: "",
                text: "Toen in 2002 en nu in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu04.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu04.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu04.jpg`,
                alt: "",
                text: "Toen in 2002 en nu in 2017."
            },
            {
                mobile: `${imageFolder}slideshow4/ToenEnNu05.jpg`,
                tablet: `${imageFolder}slideshow4/ToenEnNu05.jpg`,
                desktop: `${imageFolder}slideshow4/ToenEnNu05.jpg`,
                alt: "",
                text: "Toen in 2002 en nu in 2017."
            }
        ],
    },
    {
      type: "Paragraph",
      text: "Deze grote woorden komen deels voort uit Israëls vrees voor aantasting van zijn positie. Ook al keert het grootste deel van de internationale gemeenschap zich tegen de al decennia durende bezetting, tot nu toe komt Israël er aardig mee weg. Zelfs tegen het voortdurend uitbreiden van Joodse nederzettingen op de Westelijke Jordaanoever treedt de internationale gemeenschap nauwelijks op. Maar als de BDS-beweging erin zou slagen om de illegaliteit van de bezetting in de hoofden en harten van het westerse publiek te planten, heeft Israël een probleem. Een ander argument om hard tegen de BDS-beweging op te treden, is de binnenlandse politiek: Israëlische kiezers stemmen op politici die laten zien dat ze zich tot het uiterste inspannen om voor hun land op te komen."
    },
    {
      type: "Paragraph",
      text: "Israël spendeert veel geld – in 2016 is het 30 miljoen euro – om internationaal tegen BDS te lobbyen. In december 2017 maakte de Israëlische regering bekend dat er nog eens 62,5 miljoen euro uitgetrokken wordt om BDS tegen te gaan, onder meer door druk op artiesten te pareren, publieke campagnes, het uitnodigen van opiniemakers voor ‘solidariteitsbezoekjes’ aan Israël, grotere zichtbaarheid en meer coördinatie tussen pro-Israëlische groeperingen wereldwijd. De nieuwe miljoenen worden gezamenlijk opgebracht door Israël en enkele Joodse weldoeners. En hun  lobbywerk lukt aardig. Zo heeft de Britse regering bepaald dat overheidsinstanties – zoals gemeenten en zorginstellingen – niet langer mogen oproepen tot een boycot van Israël. Ook in Frankrijk, Canada en de Verenigde Staten boekt de anti-BDS-lobby successen."
    },
    {
      type: "Paragraph",
      text: "Volgens Fred Grünfeld, gepensioneerd hoofddocent internationale betrekkingen aan de Universiteit Maastricht en emeritus hoogleraar oorzaken van mensenrechtenschendingen aan de Universiteit Utrecht, is het uitzonderlijk dat landen zo actief zijn in het bestrijden van een boycotbeweging tegen een ander land. Eén voorbeeld kan hij zich herinneren: in de jaren zeventig werden er in de VS twee wetten aangenomen die de boycot van Israël door de Arabische Liga moesten tegengaan. De felheid van de anti-BDS-beweging in deze westerse landen, zegt Grünfeld, kan te maken hebben met de vrees dat boycots van Israël kunnen bijdragen aan antisemitisme. Zo wijst hij op Frankrijk, waar de afgelopen jaren enkele antisemitische incidenten hebben plaatsgehad. Het land treedt relatief streng op tegen mensen en organisaties die een Israël-boycot bepleiten."
    },
    {
      type: "Paragraph",
      text: "Israël kan de steun van westerse bondgenoten goed gebruiken. Maar kritiek is er ook. Zo bestempelt de Britse Labour-partij het wettelijk tegengaan van BDS als een ‘aanval op de democratie’. Want valt het niet, zo redeneert de partij, onder de vrijheid van meningsuiting om op te roepen tot een boycot van een land dat een ander volk onderdrukt? Amnesty International vindt dat het overheidsinstanties vrij moet staan om ethisch verantwoord te investeren – en dat ze dus ook de keuze moeten hebben om hun reserves níét in Israël aan te wenden. Roger Waters, frontman van Pink Floyd en een voornaam BDS-activist, noemt het op Radio Canada ‘gevaarlijk’ dat de Verenigde Staten en Canada ‘een niet-gewelddadige vorm van protest tegen een buitenlandse mogendheid’ strafbaar stellen. ‘Ik vind het een zeer verontrustende gedachte dat er van een gewone mensenrechtenorganisatie waar ik onderdeel van ben een illegale organisatie gemaakt kan worden, en dat ik opgesloten kan worden voor mijn aandeel erin.’"
    },
    {
      type: "Paragraph",
      text: "Paradoxaal genoeg vaart de BDS-beweging wel bij Israëlisch verzet. Zelf incasseren de initiatiefnemers van de beweging niets liever dan een stevige aanval van premier Netanyahu: aandacht gegarandeerd. Evenmin was de beweging ongelukkig met een conferentie die in Israël gehouden werd om BDS te bestrijden, georganiseerd door de brede publiekskrant Yedioth Ahronoth (‘Laatste Nieuws’) en bijgewoond door tal van politici, van links tot rechts. Hoogtepunt was een optreden van de Joods-Amerikaanse comédienne Roseanne Barr, die de BDS-beweging ‘fascistisch’ noemde."
    },
    {
      type: "Paragraph",
      text: "Niet voor niets waarschuwt president Jay Sanderson van de Jewish Federation of Greater Los Angeles dat Israël terughoudender moet zijn met het bestrijden van BDS. Hoe meer geld er naar het bestrijden van BDS gaat, zei Sanderson tegen de krant Haaretz (‘Het Land’), ‘en hoe meer mensen dit het grootste onderwerp aller tijden maken, hoe meer we de andere kant van brandstof voorzien’."
    },
    {
      type: "Paragraph",
      text: "Voor succes van de BDS-beweging is het volgens de Nederlandse hoogleraar Grünfeld van belang om Israël daar te raken waar het land het internationaal recht schendt: de illegale nederzettingen op de Westelijke Jordaanoever. ‘Je moet dus op zoek naar maatregelen die specifiek de kolonisten treffen. Als je heel Israël raakt, versterk je alleen maar de nationalistische tegenbeweging. En je kweekt er geen sympathie mee.’"
    },
    {
      type: "Paragraph",
      text: "Met deze boodschap hoeft Grünfeld niet bij de Palestijnse hardliners aan te komen. Binnen Palestina spreekt het bijna vanzelf om een boycot aan te hangen van alles wat Israëlisch is. De BDS-beweging is er zo dominant dat elke afwijking van de norm, reëel of imaginair, tot intimidatie en bedreigingen kan leiden."
    },
    {
        type: "Slider",
        images: [
            {
                mobile: `${imageFolder}slideshow5/01djv201703101044.jpg`,
                tablet: `${imageFolder}slideshow5/01djv201703101044.jpg`,
                desktop: `${imageFolder}slideshow5/01djv201703101044.jpg`,
                alt: "",
                text: "Het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp, dat gebouwd is na 2002."
            },
            {
                mobile: `${imageFolder}slideshow5/02djv201703101083.jpg`,
                tablet: `${imageFolder}slideshow5/02djv201703101083.jpg`,
                desktop: `${imageFolder}slideshow5/02djv201703101083.jpg`,
                alt: "",
                text: "Op de nieuwe huizen is overal al graffiti gespoten, die verwijst naar martelaren en hun brigades."
            },
            {
                mobile: `${imageFolder}slideshow5/03djv201703101136.jpg`,
                tablet: `${imageFolder}slideshow5/03djv201703101136.jpg`,
                desktop: `${imageFolder}slideshow5/03djv201703101136.jpg`,
                alt: "",
                text: "Straatbeeld van het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp."
            },
            {
                mobile: `${imageFolder}slideshow5/04djv201703101194.jpg`,
                tablet: `${imageFolder}slideshow5/04djv201703101194.jpg`,
                desktop: `${imageFolder}slideshow5/04djv201703101194.jpg`,
                alt: "",
                text: "Martelarenposters van Fatah, Hamas en de Islamitische Jihad. In het zwart staat geschreven: 'Brigade Mohammed Asama'."
            },
            {
                mobile: `${imageFolder}slideshow5/05djv201703100986.jpg`,
                tablet: `${imageFolder}slideshow5/05djv201703100986.jpg`,
                desktop: `${imageFolder}slideshow5/05djv201703100986.jpg`,
                alt: "",
                text: "Het Jenin-vluchtelingenkamp in 2017."
            },
            {
                mobile: `${imageFolder}slideshow5/06djv201703101007.jpg`,
                tablet: `${imageFolder}slideshow5/06djv201703101007.jpg`,
                desktop: `${imageFolder}slideshow5/06djv201703101007.jpg`,
                alt: "",
                text: "De herdenkingssteen voor Ahmad Hassen, die als martelaar is omgekomen."
            },
            {
                mobile: `${imageFolder}slideshow5/07djv201703101227.jpg`,
                tablet: `${imageFolder}slideshow5/07djv201703101227.jpg`,
                desktop: `${imageFolder}slideshow5/07djv201703101227.jpg`,
                alt: "",
                text: "Straatbeeld van het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp. "
            },
            {
                mobile: `${imageFolder}slideshow5/08djv201703100999.jpg`,
                tablet: `${imageFolder}slideshow5/08djv201703100999.jpg`,
                desktop: `${imageFolder}slideshow5/08djv201703100999.jpg`,
                alt: "",
                text: "Muur waarop staat dat alle gevangenen helden zijn, aangevuld met namen."
            },
            {
                mobile: `${imageFolder}slideshow5/09djv201703101055.jpg`,
                tablet: `${imageFolder}slideshow5/09djv201703101055.jpg`,
                desktop: `${imageFolder}slideshow5/09djv201703101055.jpg`,
                alt: "",
                text: "Straatbeeld in het nieuwbouwgedeelte van het Jenin-vluchtelingenkamp. 'Mogen de martelaren voor altijd in de hemel zijn',  staat er links op de muur geschreven."
            },
            {
                mobile: `${imageFolder}slideshow5/10djv201703101049.jpg`,
                tablet: `${imageFolder}slideshow5/10djv201703101049.jpg`,
                desktop: `${imageFolder}slideshow5/10djv201703101049.jpg`,
                alt: "",
                text: "Muurschildering met een sleutel en de zee, wat het verlangen naar terugkeer van de vluchtelingen in Jenin naar het huidige Israël symboliseert. Op de posters worden martelaren herdacht en mensen gefeliciteerd die zijn vrijgekomen uit Israëlische gevangenschap."
            }
        ],
    },
    {
      type: "Paragraph",
      text: "Is het echt zo dat de jongens in Jenin aan normalisatie hebben gedaan door mee te werken aan een journalistieke productie waarin ook Joodse kolonisten figureren? Je zou ook kunnen beweren dat de door hen ervaren intimidatie de persvrijheid in Palestina bedreigt. Nu is het daarmee toch al niet zo best gesteld: op de ranglijst van landen met de hoogste persvrijheid, opgesteld door de ngo Verslaggevers Zonder Grenzen, staat Palestina 135ste, vlak achter Algerije. Vrije toegang tot informatie is voor Palestijnse verslaggevers niet gegarandeerd. Vooral Fatah-aanhangers in de Gazastrook en Hamas-fans op de Westelijke Jordaanoever staan geregeld onder druk of worden zelfs mishandeld."
    },
    {
      type: "Paragraph",
      text: "Israël doet het net iets beter: dat land staat gedeeld 91ste, samen met Nicaragua. De ngo wijst onder meer op militaire censuur en aanvallen door Israëlische ordetroepen op Palestijnse en buitenlandse journalisten, vooral tijdens demonstraties."
    },
    {
      type: "Paragraph",
      text: "Als makers van de documentaire hebben we zelf meer te lijden gehad van de Israëliërs: verslaggever Derk Walters kreeg in 2017 geen nieuwe perskaart plus de daaraan gekoppelde verblijfsvergunning meer, waardoor hij gedwongen was om zijn verblijf in de regio te beëindigen. Dat we begin 2018 wegens Palestijnse druk gedwongen zijn om een verhaal uit The Holy Road te schrappen, komt als een even late als onaangename verrassing."
    },
]



// WEBPACK FOOTER //
// ./src/data/nl/stories/story7.js